import { disableBodyScroll } from 'body-scroll-lock';
import closeAllMenus from '../../core/INF-closeAllMenus';

export default function () {
  const state = document.querySelector('[data-state]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const hamburger = document.querySelector('[data-hamburger]');

  // HAMBURGER
  document.addEventListener('click', (event) => {
    const hamburgerElement = event.target.closest('[data-hamburger]');

    if (hamburgerElement) {
      if (state.classList.contains('State--mobile-menu-open')) {
        closeAllMenus();
        return;
      }

      closeAllMenus();
      state.classList.add('State--mobile-menu-open');
      disableBodyScroll(mobileMenu);

      window.dispatchEvent(new Event('scroll'));
    }
  });

  // Close mobile menu if you open it then trip the breakpoint (tablet portrait with menu open -> tablet landscape for example)
  window.addEventListener('resize', () => {
    if (state.classList.contains('State--mobile-menu-open') && getComputedStyle(hamburger).display === 'none') {
      closeAllMenus();
    }
  });
}

export { closeAllMenus };
